module.exports = __webpack_public_path__ + "img/nl.4edd6757.svg";